// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moderatorBroadcasterDisplayInput {
    padding-top: 1em;
    animation: fadeInGlobal 0.4s;
}

@media only screen and (max-width: 770) {
    .moderatorBroadcasterDisplayInput {
        padding-top: 6em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Moderation/ModeratorList/ModerationListDisplay/ModeratorAddDisplay/moderatorAddDisplay.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".moderatorBroadcasterDisplayInput {\n    padding-top: 1em;\n    animation: fadeInGlobal 0.4s;\n}\n\n@media only screen and (max-width: 770) {\n    .moderatorBroadcasterDisplayInput {\n        padding-top: 6em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
